let goodsData = [
//{
//"id": 1000271,
//"name": "蓝牙电子钥匙",
//"name_title": "蓝牙授权，开锁自动上传记录",
//"model": "CG-MNKEY-1",
//"sku_info": [{
//  "sku_id": 1000271,
//  "ali_image":require('@/assets/img/products/blekey/key2/blekey3.jpg'),
//  "spec_json": {
//    "show_name": "正面"
//  }
//},{
//  "sku_id": 1000271,
//  "ali_image":require('@/assets/img/products//blekey/key2/blekey1.jpg'),
//  "spec_json": {
//    "image": "attr/v2/1000271/07BAF8C0EF046224A84B593DEEBC869E/",
//    "show_name": "侧面"
//  }
//}]
//},
{
  "id": 1000299,
  "name": "蓝牙电子钥匙",
  "name_title": "蓝牙授权，开锁自动上传记录",
  "model": 'CG-BGKEY-1',
  "sku_info": [{
    "sku_id": 1000299,
    "ali_image": require('@/assets/img/products//blekey/key1/blekey-1.gif'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "正面"
    }
  },
  {
    "sku_id": 1000299,
    "ali_image": require('@/assets/img/products//blekey/key1/keyDemesion.png'),
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "尺寸图纸"
    }
  }
  ]
}]

export default goodsData



// WEBPACK FOOTER //
// ./src/lib/bleKeysData.js